import "./skills.scss";

function Skills() {
    return (
        <div className="skills" id="About">
            <h1 className="skills-title">
                About me
            </h1>
            <div className="skills-group">
                <div className="skill">
                    <div className="skill-text">
                        <p>
                            Hello friend.
                        </p>
                        <p>
                            I work as frontend developer since 2019.
                            In this time I created a lot of websites and design mockups,
                            joined in good web dev communities and connected with good programers, designers.
                        </p>
                        <p>
                            I never think about my life without programming, this is what I live for,
                            this is what give me enjoy of being.
                        </p>
                    </div>

                </div>
                <div className="skill">
                    <div className="skill-block">
                        <h2 className="skill-title">
                            Experience
                        </h2>
                        <div className="skill-info">
                            Internship 6 months
                        </div>
                        <div className="skill-info">
                            Freelance 2 years
                        </div>
                    </div>
                    <div className="skill-block">
                        <h2 className="skill-title">
                            Education
                        </h2>
                        <div className="skill-info">
                            Tech Developer Degree 2021
                        </div>
                    </div>
                    <div className="skill-block">
                        <h2 className="skill-title">
                            Languages
                        </h2>
                        <div className="skill-info">
                            Russian (Fluent)
                        </div>
                        <div className="skill-info">
                            English (B1)
                        </div>
                    </div>
                </div>
                <div className="skill tools">
                    <h2 className="skill-title">
                        Tools
                    </h2>
                    <div className="skill-info">
                        Figma
                    </div>
                    <div className="skill-info">
                        Photoshop
                    </div>
                    <div className="skill-info">
                        Git
                    </div>
                    <div className="skill-info">
                        Postman
                    </div>
                </div>
                <div className="skill">
                    <h2 className="skill-title">
                        Stack
                    </h2>
                    <div className="skill-info">Angular</div>
                    <div className="skill-info">React</div>
                    <div className="skill-info">NodeJS</div>
                    <div className="skill-info">JavaScript & TypeScript</div>
                    <div className="skill-info">SCSS</div>
                    <div className="skill-info">PostgreSQL</div>
                    <div className="skill-info">MongoDB</div>
                    <div className="skill-info">GoogleFirebase</div>
                    <div className="skill-info">HTML/CSS</div>
                </div>
            </div>
        </div>
    )
}

export default Skills